import React from 'react'
import SceneProperties from '../../data/SceneProperties'

type Props = {
    left: number,
    bottom: number,
    rotate: number,
    direction: number
}

function PorkRoll(props: Props) {
    let porkClass = "porkRoll";

    if (SceneProperties.playerGlow != null) {
        porkClass += (" " + SceneProperties.playerGlow);
    } else {
        porkClass += (" blue");
    }

    return (
        <div className={porkClass} style=
            {{
                left: `${props.left}px`,
                bottom: `${props.bottom}px`,
                transform: `rotate(${props.rotate}deg)`,
                height: `${SceneProperties.playerSize}px`,
                width: `${SceneProperties.playerSize}px`
            }}>
            <div className="porkImage" style={{
                transform: `translateX(-50%) translateY(-50%) scaleX(${props.direction})`
            }}>

            </div>
        </div>
    )
}

export default PorkRoll
